import { getPaForLga, isAdmin } from '../actionHelper';
import { Carriers } from '../constants/carriers';
import { DebitsValue, RateClass } from '../constants/decision';
import { Products } from '../constants/products';
import { UserOrganization } from '../constants/userOrganization';
import { ProductConfig } from './productConfig';

export class LgaTerm extends ProductConfig {
  getCarrier(): Carriers {
    return Carriers.LGA;
  }
  getProduct(): Products {
    return Products.TERM;
  }
  availableToOrganization(org: UserOrganization): boolean {
    return [
      UserOrganization.LGA,
      UserOrganization.ETHOS,
      UserOrganization.INTEGRA,
    ].includes(org);
  }
  getColor(): string {
    return 'LgaBlue';
  }
  showPolicyCombined(roles: string[], org: string) {
    return (
      org === UserOrganization.LGA ||
      (isAdmin(roles) && org === UserOrganization.ETHOS)
    );
  }
  showPercentageAddition(rateClass: string | undefined): boolean {
    return rateClass === RateClass.STANDARD;
  }
  showDebits(rateClass: string | undefined): boolean {
    return rateClass === RateClass.STANDARD;
  }
  hasPercentageAddition(): boolean {
    return true;
  }
  hasTableRating(): boolean {
    return true;
  }
  getDebitsList(): DebitsValue[] {
    return [
      DebitsValue.Debits_0,
      DebitsValue.Debits_25,
      DebitsValue.Debits_50,
      DebitsValue.Debits_75,
      DebitsValue.Debits_100,
      DebitsValue.Debits_125,
      DebitsValue.Debits_150,
      DebitsValue.Debits_175,
      DebitsValue.Debits_200,
      DebitsValue.Debits_225,
      DebitsValue.Debits_250,
    ];
  }
  getPa(debits: number): number {
    return getPaForLga(debits);
  }
  medicalExamAvailable(): boolean {
    return true;
  }
  ETIAvailable(): boolean {
    return true;
  }
  hasAutoMedicalClaimRunButton(): boolean {
    return true;
  }
  hasStandardPlusRating(flags: any): boolean {
    return flags.standardPlusForTerm;
  }
  showTobaccoForPreferred(flags: any): boolean {
    return flags.standardPlusForTerm;
  }
  public TRLAvailable(): boolean {
    return true;
  }
}
